import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur s'est produite");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 border border-gray-100">
        {sent ? (
          <div className="text-center">
            <CheckCircle2 className="w-14 h-14 text-green-600 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-3">Email envoyé !</h1>
            <p className="text-gray-600 mb-6 text-sm">
              Si un compte existe avec <strong>{email}</strong>, vous allez recevoir un email avec
              un lien pour réinitialiser votre mot de passe. Vérifiez aussi votre dossier spam.
            </p>
            <p className="text-xs text-gray-400 mb-6">Le lien expire dans 30 minutes.</p>
            <Link to="/connexion" className="inline-flex items-center gap-2 text-[#E42313] font-semibold hover:underline">
              <ArrowLeft className="w-4 h-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <Link to="/connexion" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4">
              <ArrowLeft className="w-4 h-4" /> Retour
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Mot de passe oublié</h1>
            <p className="text-gray-600 text-sm mb-6">
              Saisissez votre email — nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>
            {error && (
              <div className="mb-5 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded text-sm">{error}</div>
            )}
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <input
                    data-testid="forgot-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border rounded focus:outline-none focus:border-[#E42313]"
                  />
                </div>
              </div>
              <button
                data-testid="forgot-submit"
                type="submit"
                disabled={submitting}
                className="w-full bg-[#E42313] text-white py-3 rounded font-semibold hover:bg-[#C11A0F] transition-colors disabled:opacity-50"
              >
                {submitting ? 'Envoi…' : 'Envoyer le lien de réinitialisation'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
